// @ts-nocheck
// Páginas standalone /termos e /privacidade — acessíveis sem login.
// Renderizadas direto no App.tsx quando window.location.pathname bate.
//
// Apple e Google Play exigem URLs públicas pra Privacy Policy e Terms.
// Por isso não podem estar atrás de auth.
import React from 'react';
import { TERMS_HTML, TERMS_VERSION, TERMS_LAST_UPDATED } from './terms-content';
import { PRIVACY_HTML, PRIVACY_VERSION, PRIVACY_LAST_UPDATED } from './privacy-content';

type Doc = 'terms' | 'privacy';

export const LegalPage: React.FC<{ doc: Doc }> = ({ doc }) => {
  const isTerms = doc === 'terms';
  const title = isTerms ? 'Termos de Uso' : 'Política de Privacidade';
  const subtitle = isTerms ? 'Como usar o Forjamente' : 'Como tratamos seus dados';
  const html = isTerms ? TERMS_HTML : PRIVACY_HTML;
  const version = isTerms ? TERMS_VERSION : PRIVACY_VERSION;
  const updated = isTerms ? TERMS_LAST_UPDATED : PRIVACY_LAST_UPDATED;

  return (
    <div style={{
      minHeight: '100vh',
      background: '#1A1614',
      color: '#F5F1EA',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
      padding: '40px 0',
    }}>
      <div style={{
        maxWidth: 760, margin: '0 auto', padding: '0 24px',
      }}>
        {/* Voltar */}
        <button
          onClick={() => {
            if (window.opener) window.close();
            else window.location.href = '/';
          }}
          style={{
            background: 'rgba(245,241,234,0.08)',
            border: '1px solid rgba(245,241,234,0.15)',
            color: '#F5F1EA',
            padding: '8px 14px',
            borderRadius: 999,
            fontSize: 12.5,
            cursor: 'pointer',
            fontFamily: 'inherit',
            marginBottom: 32,
          }}
        >
          ← Voltar
        </button>

        {/* Header */}
        <div className="mono" style={{
          fontSize: 10, letterSpacing: '0.18em', textTransform: 'uppercase',
          color: '#E87A3B', fontWeight: 600, marginBottom: 8,
        }}>Forjamente · Documentos legais</div>
        <h1 className="serif" style={{
          fontSize: 40, lineHeight: 1.05, margin: 0, letterSpacing: '-0.01em',
        }}>
          {title.split(' ').slice(0, -1).join(' ')}{' '}
          <span style={{ fontStyle: 'italic', color: '#E87A3B' }}>
            {title.split(' ').slice(-1)[0]}
          </span>
        </h1>
        <p style={{
          fontSize: 14, color: 'rgba(245,241,234,0.7)',
          marginTop: 12, lineHeight: 1.55,
        }}>{subtitle}</p>

        {/* Versão e data */}
        <div className="mono" style={{
          marginTop: 18, padding: 12, borderRadius: 10,
          background: 'rgba(245,241,234,0.04)',
          border: '1px solid rgba(245,241,234,0.08)',
          fontSize: 11.5, color: 'rgba(245,241,234,0.6)',
          letterSpacing: '0.04em',
        }}>
          Versão <strong style={{ color: '#F5F1EA' }}>{version}</strong> · Atualizada em <strong style={{ color: '#F5F1EA' }}>{updated}</strong>
        </div>

        {/* Navegação rápida entre os 2 docs */}
        <div style={{ display: 'flex', gap: 8, marginTop: 18 }}>
          <a
            href="/termos"
            style={{
              padding: '8px 14px', borderRadius: 999,
              background: isTerms ? 'rgba(232,122,59,0.18)' : 'rgba(245,241,234,0.05)',
              border: '1px solid ' + (isTerms ? 'rgba(232,122,59,0.4)' : 'rgba(245,241,234,0.1)'),
              color: isTerms ? '#E87A3B' : 'rgba(245,241,234,0.65)',
              fontSize: 12, fontWeight: 500, textDecoration: 'none',
            }}
          >Termos de Uso</a>
          <a
            href="/privacidade"
            style={{
              padding: '8px 14px', borderRadius: 999,
              background: !isTerms ? 'rgba(232,122,59,0.18)' : 'rgba(245,241,234,0.05)',
              border: '1px solid ' + (!isTerms ? 'rgba(232,122,59,0.4)' : 'rgba(245,241,234,0.1)'),
              color: !isTerms ? '#E87A3B' : 'rgba(245,241,234,0.65)',
              fontSize: 12, fontWeight: 500, textDecoration: 'none',
            }}
          >Política de Privacidade</a>
        </div>

        {/* Conteúdo */}
        <div
          className="legal-content"
          dangerouslySetInnerHTML={{ __html: html }}
          style={{ marginTop: 36 }}
        />

        <style>{`
          .legal-content {
            line-height: 1.65;
            color: rgba(245,241,234,0.85);
            font-size: 14.5px;
          }
          .legal-content h2 {
            font-family: 'Lora', Georgia, serif;
            color: #F5F1EA;
            font-size: 24px;
            margin: 36px 0 12px;
            letter-spacing: -0.005em;
          }
          .legal-content h3 {
            font-family: 'Lora', Georgia, serif;
            color: #F5F1EA;
            font-size: 18px;
            margin: 24px 0 8px;
          }
          .legal-content p {
            margin: 12px 0;
          }
          .legal-content ul, .legal-content ol {
            padding-left: 22px;
            margin: 12px 0;
          }
          .legal-content li {
            margin: 6px 0;
          }
          .legal-content strong {
            color: #F5F1EA;
            font-weight: 600;
          }
          .legal-content a {
            color: #E87A3B;
            text-decoration: underline;
          }
          .legal-content table {
            border-collapse: collapse;
            margin: 14px 0;
            width: 100%;
            font-size: 13.5px;
          }
          .legal-content th, .legal-content td {
            border: 1px solid rgba(245,241,234,0.12);
            padding: 8px 12px;
            text-align: left;
            vertical-align: top;
          }
          .legal-content th {
            background: rgba(245,241,234,0.05);
            color: #F5F1EA;
            font-weight: 600;
          }
        `}</style>

        {/* Footer */}
        <div style={{
          marginTop: 60, paddingTop: 24,
          borderTop: '1px solid rgba(245,241,234,0.08)',
          fontSize: 12.5, color: 'rgba(245,241,234,0.5)',
          textAlign: 'center', lineHeight: 1.6,
        }}>
          Forjamente · operado por Wesley David Vargas de Almeida<br/>
          CPF 050.004.071-05 · Rua Marechal Deodoro da Fonseca, 25 · Centro · Chapecó/SC · 89.801-060<br/>
          contato@forjamente.com.br
        </div>
      </div>
    </div>
  );
};
